<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px">
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('system.group.groupName')" prop="groupName">
                <el-input v-model="queryCondition.groupName" clearable></el-input>
              </el-form-item>
            </el-col>
            <!--                        <el-col :span="6">-->
            <!--                            <el-form-item :label="$t('system.group.category')" prop="category">-->
            <!--                                <el-input v-model="queryCondition.category"></el-input>-->
            <!--                            </el-form-item>-->
            <!--                        </el-col>-->
            <el-col :span="6">
              <el-form-item :label="$t('sys.userList.userName')" prop="userCd">
                <el-input v-model="queryCondition.userCd" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button type="primary" @click="queryData(1)">{{$t("common.search")}}</el-button>
            <el-button type="primary" @click="restQueryForm('queryCondition')">{{$t("common.reset")}}</el-button>
          </el-row>
        </el-form>
        <div class="toolsBox">
          <el-button type="primary" @click="addCategory">{{$t('common.addNew')}}</el-button>
          <el-button type="danger" @click="delCategory">{{$t('common.del')}}</el-button>
        </div>
        <el-table sortable :data="tableData" ref="tableList" border highlight-current-row class="table" row-key="tmGroupId">
          <el-table-column type="selection" fixed min-width="50" :reserve-selection="true"></el-table-column>
          <el-table-column show-overflow-tooltip prop="groupName" :label="$t('system.group.groupName')">
            <template slot-scope="scope">
              <el-link type="primary" @click="showDetailDialog(scope.row)">{{scope.row.groupName}}</el-link>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="leaderName" label="LeaderName"></el-table-column>
          <el-table-column show-overflow-tooltip prop="users" :label="$t('sys.userList.userName')"></el-table-column>
        </el-table>
        <div class="pagination">
          <!--===分页组件===-->
          <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :title="$t('nav.MSVGroupAdd')" :visible.sync="categoryDetailDialog" width="30%">
      <el-form v-if="categoryDetailDialog" :model="categoryDetailForm" ref="categoryDetailForm" class="categoryDetailForm" :rules="categoryDetailFormRules" label-width="120px">
        <el-row>
          <el-col :span="20">
            <el-form-item :label="$t('system.group.groupName')" prop="groupName">
              <el-input clearable v-model.trim="categoryDetailForm.groupName" class="handle-input" />
            </el-form-item>
            <el-form-item label="LeaderName" prop="leaderName">
              <el-input v-model="categoryDetailForm.leaderName" clearable @clear="clearleaderId" @focus="searchleaderId">
                <i class="el-icon-search el-input_icon pointerCss" slot="suffix"></i>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('sys.userList.userName')" prop="userIds">
              <el-input v-model="categoryDetailForm.userNames" clearable @clear="clearuserNames" @focus="searchUser">
                <i class="el-icon-search el-input_icon pointerCss" slot="suffix"></i>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="categoryDetailDialog = false">{{$t('common.close')}}</el-button>
        <el-button type="primary" @click="saveCategoryDetail">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showUserDialog" append-to-body width="80%">
      <PickupUser v-if="DestroyUserDialog == true" @input="selectUser" :multi="true" :emplFlag="'MCD'"></PickupUser>
    </el-dialog>
    <el-dialog :visible.sync="showLeaderDialog" append-to-body width="80%">
      <PickupUser @selectRows="selectLeader" :emplFlag="'MCD'"></PickupUser>
    </el-dialog>
  </div>
</template>

<script>
import dataTableUtils from "@/utils/dataTableUtils";
import group from "@/api/system/group";
import commonFun from "@/utils/commonFun";
import IcSelect from "@/components/common/icSelect";
import PickupUser from "@/components/page/sensory/sensory-template/choiceUser";

export default {
  name: "categoryGroupList",
  extends: dataTableUtils,
  components: { IcSelect, PickupUser },
  computed: {
    category() {
      return code => {
        if (commonFun.isNotEmpty(code)) {
          return commonFun.getICVal("BASE", code.substr(0, 2), code);
        }
        return "";
      };
    }
  },
  created() {
    this.queryData();
  },
  data() {
    return {
      DestroyUserDialog: "",
      categoryDetailDialog: false,
      showUserDialog: false,
      showLeaderDialog: false,
      categoryDetailForm: {
        groupName: "",
        groupType: "MSV",
        userNames: "",
        userIds: [],
        leaderName: "",
        leaderId: ""
      },
      queryCondition: {
        groupName: "",
        category: "",
        userCd: "",
        pageNum: 1,
        pageSize: 15
      },
      categoryDetailFormRules: {
        groupName: [
          {
            required: true,
            message: this.$t("visitPlan.noEmpty"),
            trigger: "change"
          }
        ]
      },
      totalCount: null,
      tableData: []
    };
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      group.msvGroups(this.queryCondition).then(res => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
      });
    },
    addCategory() {
      let that = this;
      this.categoryDetailForm.groupName = "";
      this.categoryDetailForm.userNames = "";
      this.categoryDetailForm.tmGroupId = "";
      this.categoryDetailForm.userIds = [];
      this.categoryDetailForm.leaderName = "";
      this.categoryDetailForm.leaderId = "";
      that.categoryDetailDialog = true;
    },
    showDetailDialog(row) {
      console.log(row);
      this.categoryDetailForm.groupName = row.groupName;
      this.categoryDetailForm.userNames = row.users;
      this.categoryDetailForm.tmGroupId = row.tmGroupId;
      this.categoryDetailForm.leaderId = row.leaderId;
      this.categoryDetailForm.leaderName = row.leaderName;

      if (commonFun.isNotEmpty(row.userIds)) {
        this.categoryDetailForm.userIds = row.userIds;
      } else {
        this.categoryDetailForm.userIds = [];
      }
      this.categoryDetailDialog = true;
    },
    delCategory() {
      let that = this;
      let rows = this.$refs.tableList.selection;
      if (rows.length == 0) {
        that.$message({
          message: that.$t("common.pleaseSelectData"),
          type: "warning"
        });
      } else {
        let ids = rows.map(data => data.tmGroupId).join(",");
        // 请确认是否删除!
        this.$confirm(this.$t('common.delConfirm'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          cancelButtonClass: 'el-button--primary',
          confirmButtonClass: 'el-button--primary',
          // customClass:'colorBtn',
          type: 'warning'
        }).then(() => {
          group.delGroups(ids).then(res => {
            if (res.code == 200) {
              that.$message({
                message: this.$t("common.delSuccess"),
                type: "success"
              });
              that.queryData(1);
              this.$refs.tableList.clearSelection()
            }
          });
        }).catch(() => {

        });

      }
    },
    saveCategoryDetail() {
      let that = this;
      this.$refs.categoryDetailForm.validate(valid => {
        if (valid) {
          console.log(this.categoryDetailForm);
          group.saveGroups(this.categoryDetailForm).then(res => {
            console.log(res);
            if (res.code == 200) {
              that.$message({
                message: this.$t("common.saveSuccess"),
                type: "success"
              });
              that.queryData();
              this.categoryDetailDialog = false;
            }
          });
        }
      });
    },
    searchUser() {
      this.$nextTick(() => {
        this.DestroyUserDialog = true;
      });
      this.showUserDialog = true;
    },
    searchleaderId() {
      this.showLeaderDialog = true;
    },
    selectUser(list) {
      let that = this;
      that.categoryDetailForm.userIds = [];
      if (list.length > 0) {
        list.forEach(item => {
          that.categoryDetailForm.userIds.push(item.tmUserId);
        });
        that.categoryDetailForm.userNames = list
          .map(data => data.username)
          .join(",");
      }
      that.DestroyUserDialog = false; //为了重新渲染子组件
      that.showUserDialog = false;
      console.log(list);
    },
    selectLeader(obj) {
      console.log(obj);
      this.categoryDetailForm.leaderId = obj.tmUserId;
      this.categoryDetailForm.leaderName = obj.username;
      this.showLeaderDialog = false;
    },

    clearleaderId() {
      this.categoryDetailForm.leaderId = "";
    },
    clearuserNames() {
      this.categoryDetailForm.userIds = [];
    }
  }
};
</script>

<style scoped lang="scss">
.table {
  margin-top: 10px;
}
.categoryDetailForm {
  .el-input {
    width: 100%;
  }
}
</style>
